define('app/ss/contact/additionalinfo/ss-contact-additionalinfo',["service!sds-additionaldata"], function (sdsAdditionalDataService) {
	return {
		controller: {
			prototype: {
				loadAdditionalInfo: function loadAdditionalInfo() {
					var vm = this;
					return vm.loading = sdsAdditionalDataService().then(function (additionalInfo) {
						vm.additionalInfo = additionalInfo;
					}).then(function $then() {
						vm.failedLoad = false;
					}, function $catch() {
						vm.failedLoad = true;
					});
				}
			},
			constructor: ["$self", function (vm) {
				vm.loadAdditionalInfo();
			}]
		}
	}
});
